import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import axios from 'axios';
const EmployeeDocumentModal = ({
    showModal,
    handleClose,
    editEmployeeDocument,
    addEmployeeDocument,
    EmployeeDocumentData,
    EmployeeDocumentId
}) => {
    const [formData, setFormData] = useState({
        document_type: '',
        document_number: '',
        issue_date: '',
        expiry_date: '',
        file_path: '',
    });

    const [errors, setErrors] = useState({});
    const [previewUrl, setPreviewUrl] = useState(null);

   useEffect(() => {
    if (showModal && !EmployeeDocumentData) {
        // Reset for "Add"
        setFormData({
            document_type: '',
            document_number: '',
            issue_date: '',
            expiry_date: '',
            file_path: '',
        });
        setPreviewUrl(null);
    } else if (EmployeeDocumentData) {
        // Populate for "Edit"
        setFormData({
            document_type: EmployeeDocumentData.document_type || '',
            document_number: EmployeeDocumentData.document_number || '',
            issue_date: EmployeeDocumentData.issue_date || '',
            expiry_date: EmployeeDocumentData.expiry_date || '',
            file_path: EmployeeDocumentData.file_path || '',
        });

        // ✅ build full file URL for preview
        if (EmployeeDocumentData.file_path) {
            const backendUrl = process.env.REACT_APP_BACKEND_URL; // e.g. http://127.0.0.1:8000
            setPreviewUrl(`${backendUrl}/storage/${EmployeeDocumentData.file_path}`);
        } else {
            setPreviewUrl(null);
        }
    }
}, [EmployeeDocumentData, showModal]);


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, file_path: file });
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    // Clear preview when user clicks X
    const handleClearPreview = () => {
        setPreviewUrl(null);
        setFormData({ ...formData, file_path: '' });
    };
    const validateForm = () => { const newErrors = {}; if (!formData.document_type) newErrors.document_type = 'Document Type is required'; if (!formData.document_number) newErrors.document_number = 'Document No is required'; if (!formData.issue_date) newErrors.issue_date = 'Issue Date is required'; if (!formData.expiry_date) newErrors.expiry_date = 'Expiry Date is required'; if (!formData.file_path) newErrors.file_path = 'File Path is required'; return newErrors; }; 
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };
    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setLoading(false);
        return;
    }

    // Prepare FormData for file upload
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
    });

    let apierrors;
    if (EmployeeDocumentId) {
        apierrors = await editEmployeeDocument(EmployeeDocumentId, formDataToSend);
    } else {
        apierrors = await addEmployeeDocument(formDataToSend);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
        setErrors(apierrors);
        setLoading(false);
    } else {
        setErrors({});
        setPreviewUrl(null); // reset preview
        handleClose();
        setLoading(false);
    }
};

    // ✅ Preview section now with Close (X) button
    const renderPreview = () => {
        if (!previewUrl) return null;
        return (
            <div className="mb-3 position-relative">
                <button
                    type="button"
                    onClick={handleClearPreview}
                    className="btn-close position-absolute top-0 end-0 m-2"
                    aria-label="Close"
                />
                {formData.file_path?.type?.includes("image") || previewUrl.endsWith(".jpg") || previewUrl.endsWith(".png") ? (
                    <img
                        src={previewUrl}
                        alt="Preview"
                        style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "8px" }}
                    />
                ) : (
                    <iframe
                        src={previewUrl}
                        title="File Preview"
                        style={{ width: "100%", height: "200px", border: "1px solid #ddd", borderRadius: "8px" }}
                    />
                )}
            </div>
        );
    };

    return (
        <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '490px' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    {EmployeeDocumentId ? 'Edit Document' : 'Add Document'}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} />

            <Offcanvas.Body>
                <Form onSubmit={handleSubmit}>
                    {/* ✅ Show Preview above file input */}
                    {renderPreview()}

                    <Form.Group className="mb-3" controlId="documentType">
                        <Form.Label style={{ fontSize: '13px' }}>Document Type:</Form.Label>
                        <Form.Control
                            type="text"
                            name="document_type"
                            value={formData.document_type}
                            onChange={handleChange}
                            className={`form-control ${errors?.document_type ? 'is-invalid' : ''}`}
                            style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        />
                        {errors.document_type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.document_type}</div>}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="documentNumber">
                        <Form.Label style={{ fontSize: '13px' }}>Document No:</Form.Label>
                        <Form.Control
                            type="text"
                            name="document_number"
                            value={formData.document_number}
                            onChange={handleChange}
                            style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="issueDate">
                        <Form.Label style={{ fontSize: '13px' }}>Issue Date:</Form.Label>
                        <Form.Control
                            type="date"
                            name="issue_date"
                            value={formData.issue_date}
                            onChange={handleChange}
                            style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="expiryDate">
                        <Form.Label style={{ fontSize: '13px' }}>Expiry Date:</Form.Label>
                        <Form.Control
                            type="date"
                            name="expiry_date"
                            value={formData.expiry_date}
                            onChange={handleChange}
                            style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                        />
                    </Form.Group>

                    {/* File upload only shows if no preview */}
                    {!previewUrl && (
                        <Form.Group className="mb-3" controlId="documentFile">
                            <Form.Label style={{ fontSize: '13px' }}>File:</Form.Label>
                            <Form.Control
                                type="file"
                                name="file_path"
                                onChange={handleFileChange}
                                style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                            />
                        </Form.Group>
                    )}

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleClose} className="me-2">
                            Close
                        </Button>
                        <Button variant="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};


export default EmployeeDocumentModal;
